export default __webpack_public_path__ + "static/media/satellite.cdeb493f.png";